import { useContext, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import AuthContext from 'contexte/AuthContext';
import { launchError, launchSuccess } from 'components/notifications';
import { uploadSpTermSheet } from 'services/structuredProductsServices';
import { couponsErrorLabel } from './couponsErrors';

const TermSheetUploadButton = ({ productId, onUploaded, className, label = 'Ajouter le term sheet' }) => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const readAsDataURL = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  })

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (file.type !== 'application/pdf') return launchError('Le term sheet doit être un PDF');
    try {
      setUploading(true);
      const result = await uploadSpTermSheet({ user, productId, file: await readAsDataURL(file) });
      launchSuccess(t('notifications.structured_products.term_sheet.success'));
      if (result.coupons_created) launchSuccess(`${result.coupons_created} coupons créés`);
      else if (result.coupons_error) launchError(couponsErrorLabel(result.coupons_error));
      onUploaded?.(result);
    } catch (error) {
      launchError(t('notifications.structured_products.term_sheet.error'));
    } finally {
      setUploading(false);
    }
  }

  return (
    <>
      <input ref={inputRef} type="file" accept="application/pdf" hidden onChange={handleFileChange} />
      <button className={className} disabled={uploading} onClick={() => inputRef.current?.click()}>
        {uploading ? 'Envoi...' : label}
      </button>
    </>
  )
}

export default TermSheetUploadButton
